import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { User as BackendUser } from "../../types/user";
import { ENDPOINTS } from "../../config";

export const useGetCurrentUser = (opts?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ["current-user"],
    queryFn: async (): Promise<BackendUser> => {
      const resp = await fetchClient<BackendUser>(ENDPOINTS.profile, { method: "GET" });
      if (resp.error || !resp.data) {
        throw resp.error || new Error("Failed to fetch current user");
      }
      return resp.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: opts?.enabled ?? true,
    retry: 1,
  });

export default useGetCurrentUser;
